import { render, staticRenderFns } from "./NinetyNineLogo.vue?vue&type=template&id=2cb5113a&scoped=true&"
import script from "./NinetyNineLogo.vue?vue&type=script&lang=ts&"
export * from "./NinetyNineLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5113a",
  null
  
)

export default component.exports